import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const AdminBookings = () => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Admin - Bookings Management
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Bookings management page - coming soon.
      </Typography>
    </Box>
  );
};

export default AdminBookings;